import React, {Component} from 'react';
// helpers
import { getTennisOrBaseballMarketName} from '../../../helpers/marketHelpers';
import {getText} from '../../../../../helpers/localization';
// components
import LockedBet from '../../../components/lockedBet';
import {PLACED, VOIDED} from "../../../../../constants/identifiers";
import style from "../../../css/lockedBetCricket.css";
import {getGameTitle} from "../../../../../helpers/eventHelpers";
import {ALL_BASEBALL_MARKETS} from "../constants/marketTypes";
import { toSentenceCase } from '../helpers/marketHelpers';


class LockedBetBaseBall extends Component {

    _createEventDetails(eventDetails) {
        let winnerName = eventDetails.fullTimeResult.split(";")[1];
        let teamScore = eventDetails.fullTimeResult.split(";")[0];
        return (
          <div>
            <div className={`${style.eventDetailsLine} ${style.even}`}>
              <div className={style.eventDetailsLineLeft}>
                {toSentenceCase(getText("WINNER", this.props.store))}
              </div>
              <div className={style.eventDetailsLineRight}>
                {toSentenceCase(winnerName)}
              </div>
            </div>
            <div className={`${style.eventDetailsLine}`}>
              <div className={style.eventDetailsLineLeft}>
                {getText("HOME RUNS", this.props.store, [
                  toSentenceCase(eventDetails.homeTeam),
                ])}
              </div>
              <div className={style.eventDetailsLineRight}>
                {teamScore.split("-")[0]}
              </div>
            </div>
            <div className={`${style.eventDetailsLine} ${style.even}`}>
              <div className={style.eventDetailsLineLeft}>
                {getText("HOME RUNS", this.props.store, [
                  toSentenceCase(eventDetails.awayTeam),
                ])}
              </div>
              <div className={style.eventDetailsLineRight}>
                {teamScore.split("-")[1]}
              </div>
            </div>
          </div>
        );
    }

    render() {
        let eventDetails;
        let bet = this.props.betSelection.Bets[0];
        let marketTypeList = ALL_BASEBALL_MARKETS;
        let marketInfo = bet.OpaqueData === undefined ? null : JSON.parse(bet.OpaqueData);
        let selection = marketInfo && marketInfo.baseballSelection;
        let teamOne = bet.EventDetails.homeTeam.trim();
        let teamTwo = bet.EventDetails.awayTeam.trim();
        let homeTeam = teamOne.split(" ").length > 2?teamOne.split(" ")[2]:teamOne.split(" ")[1];
        let awayTeam = teamTwo.split(" ").length > 2?teamTwo.split(" ")[2]:teamTwo.split(" ")[1];
        let voidStatus = bet.State === 'VOIDED';
        let title = `${toSentenceCase(homeTeam)} ${getText('VS', this.props.store)} ${toSentenceCase(awayTeam)}`;
        let eventName = getGameTitle(title, bet.EventTime, this.props.store.getState().vpp.systemLanguage);
        let betType = toSentenceCase(getText(getTennisOrBaseballMarketName(bet.Market.Code,marketTypeList), this.props.store, [homeTeam, awayTeam]));
        let odd = bet.Market.Price;
        let name = '';
      
        if (marketInfo !== null) {
            switch (Number(marketInfo.marketCode)) {
                case 244:
                case 250:
                case 251:
                    name = toSentenceCase(getText(selection.split("_")[0],this.props.store))+" "+selection.split("_")[1]+"."+selection.split("_")[2];
                    break;
                case 247:
                  betType = getText(getTennisOrBaseballMarketName(bet.Market.Code,marketTypeList)+"_SHORT",this.props.store);
                 if(bet.Market.Num<=2){
                  name = getText(selection,this.props.store,[toSentenceCase(homeTeam)])
                 }
                 else if(bet.Market.Num>2&&bet.Market.Num<=4){
                  name = getText(selection,this.props.store,[toSentenceCase(awayTeam)])
                 }
                 else{
                  name = getText(selection,this.props.store)
                 }
                  break;
                case 245:
                  name = selection.replace(" Home Runs","");
                  break;
                default:
                  name = selection;
                  break;
          }
        }

        if (this.props.betsType !== PLACED && this.props.betsType !== VOIDED && !voidStatus) {
            eventDetails = (
                <div className={style.eventDetailsWrapper}>
                    <div className={style.eventDetails}>
                        {this._createEventDetails(bet.EventDetails)}</div>

                </div>
            );
            eventName.score = eventName.gameTitle;
            eventName.formated = (<div className={style.cricketTitle}>
                <div className={style.eventTime}>{`${eventName.dayMonthYear} `}{`${eventName.hoursMinutes} `}</div>
                <p className={style.resultContainer}>
                    {`${homeTeam} `}{` ${bet.EventDetails.fullTimeResult.split('').join(' ')} `}{` ${awayTeam}`}</p>
            </div>);
        }

        return (<LockedBet store={this.props.store} index={this.props.index} betSelection={this.props.betSelection}
                           betType={betType} odd={odd} eventName={eventName} names={[name]}
                           isSettledBet={this.props.isSettledBet} eventDetails={eventDetails}
                           voidStatus={voidStatus}/>);
    }
}

export default LockedBetBaseBall;



// WEBPACK FOOTER //
// ./src/ui-modules/sports-book/modules/baseball/components/lockedBetBaseball.js